import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventPhoneVerification = (type: "submitted" | "view") => {
    const eventData = {
        event: "phone_verified",
        event_action: type,
        event_category: "modal"
    };

    hitGoogleTagManager(eventData);
};
